import { AssessmentDefinition } from "../../../../noctem-lib/src/core/contracts/models.calculations";

export const sleepGoalsPost: AssessmentDefinition = {
  name: 'sleepGoalsPost',
  description: 'Sleep Goals',
  instructions: null,
  questions: []
};
